module.exports = __webpack_public_path__ + "static/media/coding.f67b07bf.svg";